window.NewsBgAnimation = (function(window,jQuery){
	var NewsBgAnimation = {
							polygonMap: {},
							pattern: '',
							closePosition: {
											x: $(window).width() / 2,
											y: $(window).height() / 2
											}, 
							isOpen: false,
							isAnimating: false,
							options: { 
										height: screen.height * 2,
										width: screen.width * 2,
										cell_size: 80,
										variance: 0.9,
										x_colors: ['#141414','#141414']
									  },
							svgContainer: false,
							radius: false,
							circle: false,
							animationDuration: 1.5
						 };

	NewsBgAnimation.init = function(startingState){
		if(startingState === true){
			NewsBgAnimation.isOpen = true;
		}
		NewsBgAnimation.svgContainer = $('body').find('#svgNewsBg');
		NewsBgAnimation.generateSvgShapes();
		NewsBgAnimation.calculateTriangles();
		if(startingState === true){
			NewsBgAnimation.animate('open');
		}
	}

	NewsBgAnimation.generateSvgShapes = function(){
		NewsBgAnimation.pattern = Trianglify(NewsBgAnimation.options).svg();
		NewsBgAnimation.svgContainer.html(NewsBgAnimation.pattern);
	}

	NewsBgAnimation.calculateTriangles = function(){
		NewsBgAnimation.polygonMap = {};
	    NewsBgAnimation.polygonMap.paths = [].slice.call(NewsBgAnimation.pattern.childNodes);
	    NewsBgAnimation.polygonMap.points = [];
	    NewsBgAnimation.polygonMap.paths.forEach(function(polygon) {
	      var rect = polygon.getBoundingClientRect();
	      var point = {
	        x: rect.left + rect.width / 2,
	        y: rect.top + rect.height / 2
	      };
	      NewsBgAnimation.polygonMap.points.push(point);
	      $(polygon).attr('class', 'polygon');
	    });

	   NewsBgAnimation.svgContainer.find('svg').attr('id','svgHolder');
	   NewsBgAnimation.radius = Math.max($(window).width(), $(window).height());
	   NewsBgAnimation.circle = NewsBgAnimation.makeSVG('circle', {cx: $(window).width() / 2, cy: $(window).height() / 2, r:NewsBgAnimation.radius / 2, id: 'trackingCircle', fill: 'none'});
 	   document.getElementById('svgHolder').appendChild(NewsBgAnimation.circle);
	}

	NewsBgAnimation.animate = function(direction){
		if(direction == 'open'){
			TweenMax.fromTo(NewsBgAnimation.circle, NewsBgAnimation.animationDuration, { x: NewsBgAnimation.closePosition.x +"px", y: NewsBgAnimation.closePosition.y +"px", scale: 0 }, { x: 0 +"px", y: 0 - ($(window).height() / 2) +"px", scale: 1, onUpdate: NewsBgAnimation.animationBGCheck, onComplete: NewsBgAnimation.storeFinishedVariables(true) }); 
		} else if(direction == 'close'){
			TweenMax.fromTo(NewsBgAnimation.circle, NewsBgAnimation.animationDuration, { x: 0 +"px", y: 0 - ($(window).height() / 2) +"px", scale: 1 }, {  x: NewsBgAnimation.closePosition.x +"px", y: NewsBgAnimation.closePosition.y +"px", scale: 0, onUpdate: NewsBgAnimation.animationBGCheck, onComplete: NewsBgAnimation.storeFinishedVariables(false) }); 
		}
	}

	NewsBgAnimation.storeFinishedVariables = function(status){
		setTimeout(function(){
			NewsBgAnimation.isOpen = status;
			NewsBgAnimation.isAnimating = false;
		},1600);
	}

	NewsBgAnimation.moveCircle = function(){
		NewsBgAnimation.radius = Math.max($(window).width(), $(window).height());
		$(NewsBgAnimation.circle).attr('cx',$(window).width() / 2).attr('r',NewsBgAnimation.radius / 2);
		NewsBgAnimation.animationBGCheck();
	}

	NewsBgAnimation.animationBGCheck = function(){
		var circle = NewsBgAnimation.circle.getBoundingClientRect();
		var radius = circle.width / 2;
	    var center = {
	       x: circle.left + circle.width / 2,
	       y: circle.top + circle.height / 2
	    };
		NewsBgAnimation.polygonMap.points.forEach(function(point, i) {
	      if (NewsBgAnimation.detectPointInCircle(point, radius, center)) {
	      	var classes = "polygon polygon-hidden";
	        $(NewsBgAnimation.polygonMap.paths[i]).attr('class', classes);
	      } else {
	      	var classes = "polygon";
	      	$(NewsBgAnimation.polygonMap.paths[i]).attr('class', classes);
	      }
	    });
	}
	
	NewsBgAnimation.detectPointInCircle = function(point, radius, center) {
	    var xp = point.x,
	    	yp = point.y,
	    	xc = center.x,
	    	yc = center.y,
	    	d = radius * radius,
	    	isInside = Math.pow(xp - xc, 2) + Math.pow(yp - yc, 2) <= d;
	    return isInside;
	}

	NewsBgAnimation.setClosePosition = function(x,y){
		NewsBgAnimation.closePosition = {
			x:x,
			y:y
		}
	}

	NewsBgAnimation.makeSVG = function(tag, attrs) {
        var el= document.createElementNS('http://www.w3.org/2000/svg', tag);
        for (var k in attrs)
            el.setAttribute(k, attrs[k]);
        return el;
    }

    NewsBgAnimation.changeBgImage = function(image){
    	$('body').find('.news-inner .fullscreen-bg').css({
											    		'background': 'url("' + image + '") no-repeat center center',
											    		'background-size': 'cover'
											    		});
    }

	return NewsBgAnimation;
})(window,jQuery);